import { useAuth0 } from '@auth0/auth0-react'

import React, { ReactNode } from 'react'
import { useHistory } from 'react-router-dom'

import { isNativeApp } from '../config/auth0'
import { getLogoutOptions, prepareLogout } from '../utils/logout'

interface LogoutButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  children?: ReactNode
}
export const LogoutButton = (props: LogoutButtonProps): JSX.Element => {
  const { children, onClick: onClickProp, ...rest } = props
  const isMobileDevice = isNativeApp()
  const history = useHistory()
  const { logout, user } = useAuth0()

  return (
    <button
      type="button"
      {...rest}
      onClick={(e) => {
        prepareLogout(user?.sub)

        if (isMobileDevice) {
          // Since on a mobile device, the logout happens in a separate browser window leaving the app in its previous state,
          // we need to send them to the default route so that when they return after logging in, they are not still on a potentially private route
          history.push(`/`)
        }
        logout(getLogoutOptions())
        onClickProp?.(e)
      }}
    >
      {children || 'Logout'}
    </button>
  )
}
